import {
  useState,
  FunctionComponent
} from "react";
import ioniconaaddoutline from "../../assets/dashboard/ioniconaaddoutline.svg";
import { useQuery } from "@apollo/client";
import {
  format,
} from "date-fns";
import ioniconddocumenttextoutline_12 from "../../assets/dashboard/ioniconddocumenttextoutline.svg";
import SkeletonLoader from "../common/SkeletonLoader";
import { useAuth } from "../../context/AuthContext";
import { NOT_YET_STARTED_TASKS } from "../../api/query";
import DashTaskRow from "./DashTaskRow";
import { useNavigate } from "react-router-dom";
import PaginationNew from "../common/PaginationNew";

interface TaskListProps {
  isAddBtnDisable?: boolean;
}

const TaskList: FunctionComponent<TaskListProps> = ({ isAddBtnDisable }) => {
  const navigate = useNavigate();
  const { userInfo } = useAuth()
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4;
  const [totalPages, setTotalPages] = useState(1);

  const todayStartISOString = format(new Date(), 'yyyy-MM-dd') + "T00:00:00.000Z";

  const agencyId = parseInt(userInfo?.agency?.id);

  function handleAddTask() {
    // setIsPopupOpen(true);
    navigate("/add_task")
  }

  const {
    loading,
    error,
    data: taskData,
    refetch: refetchTask,
  } = useQuery(NOT_YET_STARTED_TASKS, {
    variables: {
      date: todayStartISOString,
      page: currentPage,
      page_size: pageSize,
    },
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setTotalPages(data?.not_yet_started_tasks?.pagination?.total_pages || 1);
    },
  });



  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
    refetchTask({
      variables: {
        date: todayStartISOString,
        page: currentPage,
        page_size: pageSize,
      },
    }); // Refetch data for the new page
  };

  const getTaskdata = taskData?.not_yet_started_tasks?.tasks;

  const itemsPerPage = [3];
  const chunkedData = [];

  let start = 0;
  for (let i = 0; i < itemsPerPage.length; i++) {
    chunkedData.push(getTaskdata?.slice(start, start + itemsPerPage[i]));
    start += itemsPerPage[i];
  }



  return (
    <div className="tasktabel-boxmain-blg">
      <div className="tasktable-box-dash-dv self-stretch shadow-[2px_2px_32px_rgba(0,_19,_85,_0.08)] rounded-lg bg-surface-bg-primary cts-dark-border box-border flex flex-col items-start justify-start pt-0 px-0 pb-1 max-w-full border-[1px] border-solid border-surface-border">
        <div className="self-stretch lightdoc-tabel-head-dv flex flex-row items-center justify-start py-[15px] px-4 box-border max-w-full  dark:bg-slate-600">
          <div className="flex-1 flex flex-row items-center justify-start gap-[10px] max-w-full">
            <b className="h-[22px] text-black dark:text-white text-xl-dv flex-1 relative inline-block max-w-[calc(100%_-_34px)]">
              Not yet Started Tasks
            </b>
            {/* {isAddBtnDisable && (
              <div
                onClick={handleAddTask}
                className="cursor-pointer flex flex-col items-start justify-start p-[10px] plus-task-btn taskdash-plush-img rounded"
              >
                <img
                  className="w-4 h-4 relative overflow-hidden shrink-0"
                  loading="lazy"
                  alt=""
                  src={ioniconaaddoutline}
                />
              </div>
            )} */}
          </div>
        </div>
        <div className={` ${getTaskdata?.length == 0 ? "tasktabel_detanotavilabe" : ""}  tasktabelbody_main-_dv removed-bdr-drk self-stretch flex flex-col items-start justify-start p-4 box-border  max-w-full text-sm text-colors-text-black mq991:overflow-x-scroll`}>
          <div className="tasktabelbody_boder self-stretch rounded-lg bg-surface-bg-primary box-border flex flex-col items-start remoced-drk-border  gap-[12px]  justify-start max-w-full mq1332:max-w-[991px] border-[1px] border-solid border-surface-border">
            {loading ? (
              <div className="w-full p-4 flex flex-col gap-4">
                <div className="flex justify-between items-center">
                  <SkeletonLoader count={1} height="h-2.5" width="w-1/2" />
                  <SkeletonLoader count={1} height="h-2" width="w-20" />
                </div>
                <div className="flex gap-4 items-center">
                  <SkeletonLoader count={1} height="h-2" width="w-1/4" />
                  <SkeletonLoader count={1} height="h-2" width="w-1/4" />
                </div>
                <div className="flex justify-between items-center">
                  <SkeletonLoader count={1} height="h-2.5" width="w-1/2" />
                  <SkeletonLoader count={1} height="h-2" width="w-20" />
                </div>
                <div className="flex gap-4 items-center">
                  <SkeletonLoader count={1} height="h-2" width="w-1/4" />
                  <SkeletonLoader count={1} height="h-2" width="w-1/4" />
                </div>
                <div className="flex justify-between items-center">
                  <SkeletonLoader count={1} height="h-2.5" width="w-1/2" />
                  <SkeletonLoader count={1} height="h-2" width="w-20" />
                </div>
                <div className="flex gap-4 items-center">
                  <SkeletonLoader count={1} height="h-2" width="w-1/4" />
                  <SkeletonLoader count={1} height="h-2" width="w-1/4" />
                </div>
              </div>
            ) : getTaskdata?.length > 0 ? (
              <>
                {getTaskdata?.map((task: any, index: any) => {
                  // const givenDate = task?.created_on; // This is in UTC
                  // const parsedDate = parseISO(givenDate); // Parse the UTC date string

                  // // Convert the parsed UTC date to IST by adding 5 hours 30 minutes (330 minutes)
                  // const istDate = addMinutes(parsedDate, 330);

                  // // Format the time distance from the IST date to the current time
                  // const formattedDate = formatDistanceToNowStrict(istDate, {
                  //   addSuffix: true,
                  // });

                  const formattedDate = format(task?.created_on, 'MM-dd-yyyy')

                  return (
                    <DashTaskRow
                      taskId={task?.id}
                      // dropdownplaceholder={task?.task_status}
                      label={task?.title}
                      date={formattedDate}
                      person={task?.created_by_name}
                      projectName={task?.project_name}
                      goalID={task?.goal_id}
                      assignedPerson={task?.members[0]?.member_name}
                      taskData={getTaskdata}
                      readOnly={task.is_readonly}
                    // refetch={refetchTask}
                    />
                  );
                })}
              </>
            ) : (
              <div className="self-stretch rounded-lg bg-slate-100 overflow-hidden dark:bg-slate-700 flex flex-col items-center justify-center py-[110px] px-[53px] gap-[8px] text-center text-text-text-secondary mq450:pl-5 mq450:pr-5 mq450:box-border">
                <img
                  className="w-9 h-9 relative overflow-hidden shrink-0"
                  alt=""
                  src={ioniconddocumenttextoutline_12}
                />
                <p className="relative my-0">No Task on Your Plate</p>
              </div>
            )}
          </div>
        </div>
        {/* Pagination Section */}
        <PaginationNew
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalPages={totalPages}
          paginationLength={
            taskData?.not_yet_started_tasks?.pagination?.total_pages > 1 ||
            currentPage != 1
          }
        />
      </div>
    </div>
  );
};

export default TaskList;
